import { Reveal } from './Reveal';
import { STATS } from '@/data';
import { INVESTOR } from '@/constants/testIds';

export const About = () => (
  <section
    id="about"
    data-testid={INVESTOR.about}
    className="mx-auto max-w-screen-2xl px-6 md:px-12 py-32 md:py-40"
  >
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
      <div className="lg:col-span-3">
        <Reveal>
          <span className="overline">01 — Le profil</span>
        </Reveal>
      </div>

      <div className="lg:col-span-9">
        <Reveal>
          <p className="font-display font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-foreground">
            Ancien opérateur devenu investisseur, Zukunft Real Estate GmbH a passé quinze ans à
            construire et à financer des produits avant de dédier son capital,
            son temps et son réseau aux fondateurs les plus ambitieux.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-12 max-w-3xl">
          <Reveal delay={0.05}>
            <p className="font-body font-light leading-relaxed text-muted-foreground">
              Il investit à titre personnel, sans fonds à déployer sous
              contrainte : une liberté qui lui permet de rester patient, franc
              et aligné avec les entrepreneurs sur le très long terme.
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="font-body font-light leading-relaxed text-muted-foreground">
              Sa valeur ajoutée : la mise à l'échelle des équipes techniques, la
              structuration go-to-market et l'accès à un réseau de co-investisseurs
              en Europe, en Israël et aux États-Unis.
            </p>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-border pt-12">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div>
                <div className="font-display text-4xl md:text-5xl text-primary tracking-tight">
                  {s.value}
                </div>
                <div className="mt-2 font-mono text-[0.65rem] uppercase tracking-[0.18em] text-muted-foreground">
                  {s.label}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
